import React from 'react';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { Card, Typography } from 'antd';

const VehicleCounts = ({ counts, getCounts, getCountsByPost }) => {
	useEffect(() => {
		getCounts();
	}, []);

	return (
		<div className="page">
			<div className="cards">
				<Card style={{ width: 200, backgroundColor: '#66c2ff' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Total Vehicles</p>
						<p className="card-value">{counts?.totalVehicles}</p>
					</Typography.Text>
				</Card>

				<Card style={{ width: 200, backgroundColor: '#ff80bf' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Featured Vehicles</p>
						<p className="card-value">{counts?.featuredVehicles}</p>
					</Typography.Text>
				</Card>

				<Card style={{ width: 200, backgroundColor: '#71da71' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Active Vehicles </p>
						<p className="card-value">{counts?.activeVehicles}</p>
					</Typography.Text>
				</Card>

				<Card style={{ width: 200, backgroundColor: '#CCCC66' }} hoverable>
					<Typography.Text>
						<p className="card-heading"> Inactive Vehicles</p>
						<p className="card-value">{counts?.inactiveVehicles}</p>
					</Typography.Text>
				</Card>

				<Card style={{ width: 200, backgroundColor: '#66c2ff' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Used Cars </p>
						<p className="card-value">{counts?.totalUsed}</p>
					</Typography.Text>
				</Card>

				<Card style={{ width: 200, backgroundColor: '#ff80bf' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Active Used Cars</p>
						<p className="card-value">{counts?.activeUsed}</p>
					</Typography.Text>
				</Card>
				<Card style={{ width: 200, backgroundColor: '#71da71' }} hoverable>
					<Typography.Text>
						<p className="card-heading">New Cars </p>
						<p className="card-value">{counts?.totalNew}</p>
					</Typography.Text>
				</Card>
				<Card style={{ width: 200, backgroundColor: '#CCCC66' }} hoverable>
					<Typography.Text>
						<p className="card-heading">Active New Cars </p>
						<p className="card-value">{counts?.activeNew}</p>
					</Typography.Text>
				</Card>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	counts: state.counts.counts,
});

const mapDispatchToProps = (dispatch) => ({
	getCountsByPost: (value) => dispatch(Actions.getCountsByPost(value)),
	getCounts: () => dispatch(Actions.getCounts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VehicleCounts));
